import {lazy} from 'react';

export const ToggleLazy = lazy(() => import(/* webpackChunkName: "toggle" */ '.'));
